import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { ref: "textDecoTop" }
const _hoisted_2 = { ref: "textDeco" }
const _hoisted_3 = { ref: "textDecoBottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.showSelf)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["text-section__headline", `text-${_ctx.align}`])
      }, [
        _createElementVNode("div", null, [
          _createElementVNode("span", _hoisted_1, null, 512),
          _createElementVNode("span", _hoisted_2, null, 512),
          _createElementVNode("span", _hoisted_3, null, 512),
          _createElementVNode("h2", null, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ])
      ], 2))
    : _createCommentVNode("", true)
}